/* ==========================================================================
 AS_SG_QV — Quick View (production build)
 --------------------------------------------------------------------------
 - Buttons are rendered server-side via snippets/as-sg-qv-button.liquid
   (one per product card). This script does NOT scan/inject the DOM for
   buttons, so it costs nothing extra whether the grid has 20 or 200 cards.
 - Modal is a single global element (snippets/as-sg-qv-modal.liquid),
   rendered once per page and reused for every product clicked.
 - All selectors are namespaced with as_sg_qv- / data-as-sg-qv-* so it
   cannot collide with existing theme JS/CSS.

 ADD TO CART: this theme's own <product-form-component> already handles
 add-to-cart submissions itself — it's bound as a document-level CAPTURE
 listener in the theme's core component.js, and its handleSubmit() does
 the AJAX POST to /cart/add.js, refreshes the cart-drawer section, AND
 opens the cart drawer, all natively. We do NOT re-implement any of that
 here (an earlier version of this file did, which caused every add-to-cart
 from Quick View to fire TWICE — once from the theme's own handler and
 once from ours — doubling the quantity and cart count). All we do now is
 close the Quick View modal shortly after a submit, so the person sees
 their own cart drawer (opened by the theme) instead of the modal.
 ========================================================================== */
 (function () {
  "use strict";

  // Guard against this script being loaded twice on the same page
  // (e.g. included in both theme.liquid and an app embed) — a second
  // run would double-bind every delegated listener below.
  if (window.__asSgQvInitialized) return;
  window.__asSgQvInitialized = true;

  function waitUntil(predicate, success, error) {
    var int = setInterval(function () {
      if (predicate()) {
        clearInterval(int);
        int = null;
        success();
      }
    }, 33);

    setTimeout(function () {
      if (int !== null) {
        clearInterval(int);
        if (typeof error === "function") error();
      }
    }, 10000);
  }

  // Generation token: guards against a stale (older) load hiding the loader
  // — or, more importantly, re-initializing Slick on markup that belongs to
  // a NEWER render — when the user clicks buttons/swatches rapidly.
  window.__asSgQvGen = 0;

  /* ------------------------------------------------------------------
     In-session caches (per page load).
     - productCache: /products/handle.js JSON → used for the gallery
     - htmlCache:    product page HTML        → used for the details panel
     Both cache the in-flight PROMISE so hover-prefetch + click reuse the
     same request, and re-opening the same product/color is instant.
  ------------------------------------------------------------------ */
  var productCache = {};
  var htmlCache = {};

  function getProduct(handle) {
    if (!handle) return Promise.reject(new Error("as_sg_qv: missing handle"));
    if (!productCache[handle]) {
      productCache[handle] = fetch("/products/" + handle + ".js")
        .then(function (r) { return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }

  function getPageHtml(url) {
    if (!url) return Promise.reject(new Error("as_sg_qv: missing url"));
    if (!htmlCache[url]) {
      htmlCache[url] = fetch(url)
        .then(function (r) { return r.text(); })
        .catch(function (e) { delete htmlCache[url]; throw e; });
    }
    return htmlCache[url];
  }

  /* The details panel is server-rendered with the cart baked in (e.g. the
     membership "+ Add" button only renders while the membership is NOT in
     the cart), so cached page HTML goes stale the moment the cart changes.
     Drop it on every theme cart update, and when the page is restored from
     the back/forward cache, so the next open re-fetches the current state.
     productCache (/products/handle.js) is cart-independent, so it stays. */
  function clearHtmlCache() {
    htmlCache = {};
  }

  document.addEventListener("cart:update", function (e) {
    clearHtmlCache();

    // A cart add from INSIDE the modal that goes through the theme's own
    // events (e.g. the membership "+ Add", see membership-add-to-cart.js)
    // auto-opens the cart drawer — close the modal so it isn't covering it.
    var fromModal = e.target instanceof Element && e.target.closest("#as_sg_qv-modal");
    if (fromModal && $("#as_sg_qv-modal").hasClass("as_sg_qv-active")) {
      closeModal();
    }
  });
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) clearHtmlCache();
  });

  /* ------------------------------------------------------------------
     Destroy any existing slick sliders BEFORE re-rendering, so no
     orphaned slick state is left behind on a color/product change.
  ------------------------------------------------------------------ */
  function destroySliders() {
    if ($(".as_sg_qv-slider-for").hasClass("slick-initialized")) {
      $(".as_sg_qv-slider-for").slick("unslick");
    }
    if ($(".as_sg_qv-slider-nav").hasClass("slick-initialized")) {
      $(".as_sg_qv-slider-nav").slick("unslick");
    }
  }

  /* renderGallery fires onReady ONLY after slick has initialized, so the
     caller can keep the loader up until the gallery is actually laid out
     (avoids flicker/reflow).

     `gen` is the generation token captured by the CALLER at the moment it
     decided to render; a stale render bails out instead of initializing
     Slick on markup that belongs to a newer product/color. */
  function renderGallery(product, onReady, gen) {
    var images = (product.images || [])
      .map(function (img, index) {
        return (
          '<div class="as_sg_qv-thumb-slide"><img src="' + img + '" ' +
          'class="as_sg_qv-thumb' + (index === 0 ? " active" : "") + '" ' +
          'data-image="' + img + '" /></div>'
        );
      })
      .join("");

    var imagesNav = (product.images || [])
      .map(function (img, index) {
        return (
          '<div><img src="' + img + '" ' +
          'class="as_sg_qv-thumb' + (index === 0 ? " active" : "") + '" ' +
          'data-image="' + img + '" /></div>'
        );
      })
      .join("");

    // Tear down the previous gallery only now, right before replacing it,
    // so a color switch never shows an empty left column while loading.
    destroySliders();
    document.querySelector("#as_sg_qv-content .as_sg_qv-left-side-content").innerHTML =
      '<div class="as_sg_qv-wrapper">' +
        '<div class="as_sg_qv-gallery">' +
          '<div class="as_sg_qv-img-slide">' +
            '<div class="as_sg_qv-slider-for">' + images + "</div>" +
            '<div class="as_sg_qv-slider-nav">' + imagesNav + "</div>" +
          "</div>" +
        "</div>" +
      "</div>";

    // Slick is initialized in the SAME task as the innerHTML swap above, so
    // the browser never paints the raw, un-sliced markup (every main image
    // and thumbnail stacked full-size). Deferring this (it used to run in a
    // 30ms setTimeout) let that raw frame paint whenever a frame landed in
    // the gap — the intermittent whole-gallery flash on desktop color switch.
    (function () {
      if (typeof gen !== "undefined" && gen !== window.__asSgQvGen) return;

      // Bottom-align the thumbnail rail WITHOUT breaking Slick's own
      // windowing: use the actual image count (capped at 5) as
      // slidesToShow, so Slick itself divides the available height
      // evenly across however many thumbnails really exist. Forcing
      // slidesToShow:5 when a product only has e.g. 4 images used to
      // leave a gap — but overriding Slick's track/slide CSS heights to
      // "fix" that gap (an earlier attempt) broke Slick's internal
      // windowing entirely, causing every thumbnail to stack and the
      // whole modal to balloon in height on every color switch. This is
      // the safe way to get the same visual result.
      var imgCount = (product.images || []).length;
      var navSlideCount = Math.max(1, Math.min(5, imgCount));
      var canLoop = imgCount > navSlideCount;

      var $for = $(".as_sg_qv-slider-for");
      var $nav = $(".as_sg_qv-slider-nav");

        $for.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: canLoop,
        adaptiveHeight: false,
        prevArrow: '<button type="button" class="slick-prev as_sg_qv-arrow as_sg_qv-arrow--prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none"><path d="M5.40112 0.5L0.5663 4.85134C0.478024 4.93079 0.478023 5.06921 0.566299 5.14866L5.40112 9.5" stroke="black" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next as_sg_qv-arrow as_sg_qv-arrow--next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none"><path d="M0.5 0.5L5.33482 4.85134C5.4231 4.93079 5.4231 5.06921 5.33482 5.14866L0.5 9.5" stroke="black" stroke-linecap="round"/></svg></button>',
        asNavFor: ".as_sg_qv-slider-nav",
        responsive: [
          { breakpoint: 768, settings: { arrows: false, dots: true, adaptiveHeight: true } }
        ]
      });

      $nav.slick({
        slidesToShow: navSlideCount,
        slidesToScroll: 1,
        asNavFor: ".as_sg_qv-slider-for",
        arrows: false,
        dots: false,
        infinite: canLoop,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false,
              verticalSwiping: false,
              slidesToShow: navSlideCount,
              infinite: canLoop
            }
          }
        ]
      });

      $nav.on("afterChange", function () {
        $for.slick("setPosition");
      });

      $for.find("img").each(function () {
        if (this.complete) return;
        this.addEventListener("load", function () {
          $for.slick("setPosition");
        }, { once: true });
      });
      
      setTimeout(function () {
        $for.slick("setPosition");
        $nav.slick("setPosition");
      }, 120);

      // Inject dynamic "recently bought" stock line into the slider once.
      var sliderList = $("#as_sg_qv-content .as_sg_qv-img-slide .as_sg_qv-slider-for.slick-slider .slick-list");
      if (sliderList.length && !$("#as_sg_qv-content .as_sg_qv-stock-section").length) {
        var stockBlock = document.createElement("div");
        stockBlock.className = "as_sg_qv-stock-section";
        stockBlock.innerHTML =
          '<div class="as_sg_qv-stock-bottom">' +
            '<span class="as_sg_qv-stock-count">\uD83E\uDD1D</span>' +
            '<span class="as_sg_qv-demand-text"></span>' +
          "</div>";
        sliderList[0].appendChild(stockBlock);
        updateDemandText();
      }

      if (typeof onReady === "function") onReady();
    })();
  }

  /* ------------------------------------------------------------------
     Inject the product-details fragment from the fetched page HTML.
     Scripts are stripped so nothing double-executes; theme custom
     elements (variant-picker, etc.) still upgrade normally on insert.

     preserveSwatches = true (color-switch path): the EXISTING swatch
     container node is kept and reused inside the new fragment before
     injecting, instead of taking the new fragment's own swatch markup.
     This is what stops the swatch row from re-ordering itself on every
     click — the order is fixed the moment the modal first opens.
  ------------------------------------------------------------------ */
  function renderDetails(html, handle, done, preserveSwatches) {
    closeTip(); // its markup is about to be replaced

    var doc = new DOMParser().parseFromString(html, "text/html");
    var frag = doc.querySelector(".product-details.sticky-content--desktop");
    var $right = $("#as_sg_qv-content .as_sg_qv-right-side-content");

    if (frag) {
      frag.querySelectorAll("script").forEach(function (s) { s.remove(); });

      if (preserveSwatches) {
        var oldSwatches = document.querySelector("#as_sg_qv-content .product-swatch-container");
        var newSwatches = frag.querySelector(".product-swatch-container");
        if (oldSwatches && newSwatches) {
          // The "Color: <name>" heading lives inside the reused container, so
          // carry the NEW product's colour name over before swapping it in —
          // otherwise the heading stays frozen on the first colour opened.
          var newColorName = newSwatches.querySelector(".variant-option__swatch-value");
          var oldColorName = oldSwatches.querySelector(".variant-option__swatch-value");
          if (newColorName && oldColorName) {
            oldColorName.innerHTML = newColorName.innerHTML;
          }

          newSwatches.replaceWith(oldSwatches); // reuse old node -> keeps its order
        }
      }

      $right.html(frag.outerHTML);

      // Mark the swatch matching the current handle as active — the
      // theme's own "selected" state was tied to the OLD swatch node's
      // origin page, so we own the active indicator ourselves from here.
      //
      // IMPORTANT: the reused swatch container (preserveSwatches path)
      // can carry a stale native `checked` state on its underlying
      // radio/checkbox input from whenever it was first captured — that
      // native checked state drives the theme's own CSS selection ring
      // independently of our `.as_sg_qv-swatch--active` class, which is
      // what made the DEFAULT swatch look "still selected" even after
      // clicking a different one. So we now explicitly sync the input's
      // checked PROPERTY (not just our class) to match the current handle.
      $right.find(".product-swatch").each(function () {
        var h = this.href ? this.href.split("/products/")[1].split("?")[0] : null;

        // Swatches with no real href represent the ORIGINAL product the
        // modal was first opened with (frozen into the reused container,
        // since on its own page "itself" never links out) — resolve it.
        if (!h && window.__asSgQvInitialHandle) {
          h = window.__asSgQvInitialHandle;
        }

        var isActive = !!h && h === handle;

        $(this)
          .toggleClass("as_sg_qv-swatch--active", isActive)
          .removeAttr("aria-current")
          // Strip any native "currently selected" indicator classes the
          // theme may have baked into this swatch's own markup — since the
          // container is frozen/reused, these never clear on their own and
          // end up showing alongside our own active indicator (two swatches
          // looking "selected" at once).
          .toggleClass("active", isActive)
          .toggleClass("selected", isActive)
          .toggleClass("is-selected", isActive)
          .toggleClass("current", isActive)
          .toggleClass("is-active", isActive);

        var $input = $(this).find('input[type="radio"], input[type="checkbox"]');
        if ($input.length) {
          $input.prop("checked", isActive);
        }
      });
      $right.find(".product-swatch.as_sg_qv-swatch--active").attr("aria-current", "true");
    } else {
      $right.empty();
    }

    var ratingLink = $("#as_sg_qv-content .rating-count a");
    if (ratingLink.length) {
      var currentHref = ratingLink.attr("href");
      if (currentHref && currentHref.charAt(0) === "#") {
        ratingLink.attr("href", "/products/" + handle + currentHref);
      }
    }

    formatRatingCount();
    stripAddToCartPrice();
    injectQuantity();

    if (typeof done === "function") done();
  }

  /* Quick Shop design shows the rating as "4.7 (6 reviews)"; the product
     page markup we copy reads "4.7 based on 6 reviews". Keep the link. */
  function formatRatingCount() {
    document.querySelectorAll("#as_sg_qv-content .rating-count").forEach(function (el) {
      var link = el.querySelector("a");
      if (!link || el.textContent.indexOf("based on") === -1) return;
      var rating = el.textContent.split("based on")[0].trim();
      el.textContent = rating + " (";
      el.appendChild(link);
      el.appendChild(document.createTextNode(")"));
    });
  }

  /* Quantity control (Quick Shop design). The product page's own quantity
     block is disabled in the templates, so the markup we copy has none —
     add one here. It sits inside the form (so FormData in submitAddToCart
     picks up `quantity`) but BEFORE .product-form-buttons, which the
     theme's product-form.js morphs on every size change.

     Limits follow the cart drawer's quantity selector exactly: the max is the
     variant's stock (when it stops selling at 0) or its quantity rule max, read
     from .as-sg-qv-variant-max (blocks/buy-buttons.liquid); no max otherwise.
     "+" disables at the max and a typed value snaps to it on blur/change.
     Like the product page, the modal ADDS to the cart, so the max is what's
     left after the quantity of that size already in the cart. */
  var cartQtyByVariant = {};

  function loadCartQuantities() {
    return fetch("/cart.js", { cache: "no-store", credentials: "same-origin" })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartQtyByVariant = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          cartQtyByVariant[id] = (cartQtyByVariant[id] || 0) + item.quantity;
        });
        refreshQuantityLimit();
      })
      .catch(function () {});
  }

  // Stock limit and in-cart quantity of the selected size (max null = no limit)
  function getQtyInfo(wrap) {
    var info = { max: null, inCart: 0 };
    var form = wrap.closest(".shopify-product-form");
    if (!form) return info;
    var idInput = form.querySelector("input[name='id']");
    var holder = form.querySelector(".as-sg-qv-variant-max");
    if (!idInput || !holder) return info;
    info.inCart = cartQtyByVariant[String(idInput.value)] || 0;
    try {
      var max = JSON.parse(holder.getAttribute("data-variant-max") || "{}")[String(idInput.value)];
      if (typeof max === "number") info.max = max;
    } catch (e) {}
    return info;
  }

  // Remaining quantity that can still be added for the selected size (null = no limit)
  function getQtyMax(wrap) {
    var info = getQtyInfo(wrap);
    return info.max === null ? null : Math.max(0, info.max - info.inCart);
  }

  // In stock, but all of it is already in the cart (not the same as sold out)
  function isMaxedInCart(wrap) {
    var info = getQtyInfo(wrap);
    return info.max !== null && info.max > 0 && info.inCart >= info.max;
  }

  var MAXED_LABEL = "Max Quantity In Cart";

  // Inline state instead of an alert: disable Add To Cart with a clear label and note
  function updateMaxedState(wrap) {
    var maxed = isMaxedInCart(wrap);
    var note = wrap.querySelector(".as_sg_qv-qty__note");
    if (note) note.hidden = !maxed;

    var form = wrap.closest(".shopify-product-form");
    if (!form) return;
    var $btn = $(form).find(".add-to-cart-button:not(.button-secondary)");
    var $text = $btn.find(".add-to-cart-text");

    if (maxed) {
      $btn.attr("data-as-sg-qv-maxed", "true").attr("disabled", true);
      setAddToCartLabel($text, MAXED_LABEL);
    } else if ($btn.attr("data-as-sg-qv-maxed")) {
      $btn.removeAttr("data-as-sg-qv-maxed").removeAttr("disabled");
      var label = $text.attr("data-as-sg-qv-label");
      if (!label || /sold out/i.test(label)) label = "Add To Cart";
      setAddToCartLabel($text, label);
    }
  }

  // Keep the in-cart quantities current (adds from the modal, drawer edits, etc.)
  document.addEventListener("cart:update", function () {
    if (document.querySelector("#as_sg_qv-content .as_sg_qv-qty")) loadCartQuantities();
  });

  function injectQuantity() {
    var form = document.querySelector("#as_sg_qv-content .shopify-product-form");
    if (!form || form.querySelector(".as_sg_qv-qty")) return;

    var buttons = form.querySelector(".product-form-buttons");
    var wrap = document.createElement("div");
    wrap.className = "as_sg_qv-qty";
    wrap.innerHTML =
      '<p class="as_sg_qv-qty__label">Quantity: <span class="as_sg_qv-qty__value">01</span></p>' +
      '<div class="as_sg_qv-qty__control">' +
        '<button type="button" class="as_sg_qv-qty__btn" data-as-sg-qv-qty-step="-1" aria-label="Decrease quantity" disabled>-</button>' +
        '<input type="number" name="quantity" class="as_sg_qv-qty__input" value="1" min="1" aria-label="Quantity">' +
        '<button type="button" class="as_sg_qv-qty__btn" data-as-sg-qv-qty-step="1" aria-label="Increase quantity">+</button>' +
      "</div>" +
      '<p class="as_sg_qv-qty__note" role="status" hidden>All available stock of this size is already in your cart.</p>';

    if (buttons) form.insertBefore(wrap, buttons);
    else form.appendChild(wrap);
    setQuantity(wrap, 1);
    loadCartQuantities();
  }

  function setQuantity(wrap, qty) {
    var max = getQtyMax(wrap);
    var input = wrap.querySelector(".as_sg_qv-qty__input");

    if (max !== null) input.max = Math.max(1, max);
    else input.removeAttribute("max");

    qty = Math.max(1, Math.min(max !== null ? Math.max(1, max) : Infinity, parseInt(qty, 10) || 1));
    input.value = qty;
    wrap.querySelector(".as_sg_qv-qty__value").textContent = qty < 10 ? "0" + qty : String(qty);
    wrap.querySelector('[data-as-sg-qv-qty-step="-1"]').disabled = qty <= 1;
    wrap.querySelector('[data-as-sg-qv-qty-step="1"]').disabled = max !== null && qty >= max;
    updateMaxedState(wrap);
  }

  // Size changed: re-apply the new variant's limit (snaps the quantity down if needed)
  function refreshQuantityLimit() {
    var wrap = document.querySelector("#as_sg_qv-content .as_sg_qv-qty");
    if (!wrap) return;
    setQuantity(wrap, wrap.querySelector(".as_sg_qv-qty__input").value);
  }

  // Sold-out sizes behave like the product card size buttons: not selectable.
  // Capture phase so neither the theme's variant picker nor our size handler sees the click.
  document.addEventListener(
    "click",
    function (e) {
      var label = e.target.closest && e.target.closest("#as_sg_qv-modal .variant-option__button-label");
      if (label && label.querySelector('input[aria-disabled="true"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // The theme's variant picker can also switch the variant inside the modal
  document.addEventListener("variant:update", function (e) {
    if (e.target instanceof Element && e.target.closest("#as_sg_qv-modal")) {
      setTimeout(refreshQuantityLimit, 0);
    }
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("#as_sg_qv-modal [data-as-sg-qv-qty-step]");
    if (!btn) return;
    var wrap = btn.closest(".as_sg_qv-qty");
    var input = wrap.querySelector(".as_sg_qv-qty__input");
    setQuantity(wrap, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute("data-as-sg-qv-qty-step"), 10));
  });

  document.addEventListener("change", function (e) {
    if (!e.target.matches || !e.target.matches("#as_sg_qv-modal .as_sg_qv-qty__input")) return;
    setQuantity(e.target.closest(".as_sg_qv-qty"), e.target.value);
  });

  /* The product page's CTA label is "Add To Cart • <price>"; per the Quick
     View design the CTA shows the label only. The label is kept on the
     element so the size selector can restore the same wording.

     Only the inner .add-to-cart-text__content span is ever written to — the
     theme morphs this button from the server markup on every variant change
     (product-form.js #onVariantUpdate), and flattening it to a bare text
     node made that morph ADD a fresh label beside the old one, so the CTA
     read "Add To CartAdd To Cart…" and doubled on each size tap. */
  function setAddToCartLabel($text, label) {
    $text.each(function () {
      // Drop stray bare text nodes (left over from an earlier flatten/morph)
      for (var i = this.childNodes.length - 1; i >= 0; i--) {
        if (this.childNodes[i].nodeType === 3) this.removeChild(this.childNodes[i]);
      }
      var content = this.querySelector(".add-to-cart-text__content");
      if (!content) {
        content = document.createElement("span");
        content.className = "add-to-cart-text__content";
        this.appendChild(content);
      }
      content.textContent = label;
    });
  }

  function stripAddToCartPrice() {
    $("#as_sg_qv-content .add-to-cart-text").each(function () {
      var content = this.querySelector(".add-to-cart-text__content");
      var label = (content || this).textContent.split("•")[0].replace(/\s+/g, " ").trim();
      if (!label) return;
      setAddToCartLabel($(this), label);
      $(this).attr("data-as-sg-qv-label", label);
    });
  }

  // If the theme's own variant picker updates the product form inside the
  // modal, it re-renders the button from the server with the price again
  document.addEventListener("variant:update", function (e) {
    if (e.target instanceof Element && e.target.closest("#as_sg_qv-modal")) stripAddToCartPrice();
  });

  /* ------------------------------------------------------------------
     Shared renderer. Gallery (product JSON) and details (page HTML)
     load IN PARALLEL. Loader is removed only once BOTH sides are ready,
     so the gallery never pops/reflows after the loader disappears.
  ------------------------------------------------------------------ */
  function populateModal(productPromise, htmlPromise, handle, opts) {
    opts = opts || {};
    var isSwitch = !!opts.isColorSwitch; // true = swatch click, false = initial open

    var gen = ++window.__asSgQvGen;
    var leftReady = false;
    var rightReady = false;

    function hideBusyState() {
      if (gen !== window.__asSgQvGen) return; // a newer click superseded this one
      if (leftReady && rightReady) {
        $(".as_sg_qv-container").removeClass("as_sg_qv-loader");
        $("#as_sg_qv-content").removeClass("as_sg_qv-switching");
        // The swatch row is fixed after the first open, so warm every other
        // color once, right away — otherwise the FIRST swap has to fetch the
        // page, JSON and main image on click (~1s of stale content).
        if (!isSwitch) prefetchSwatches();
      }
    }

    htmlPromise
      .then(function (html) {
        if (gen !== window.__asSgQvGen) return;
        renderDetails(html, handle, function () { rightReady = true; hideBusyState(); }, isSwitch);
      })
      .catch(function () { rightReady = true; hideBusyState(); });

    productPromise
      .then(function (product) {
        if (gen !== window.__asSgQvGen) return;
        // On a color switch the old gallery stays up until the new main
        // image is in the browser cache, so the swap doesn't flash blank.
        var preload = isSwitch ? preloadImage((product.images || [])[0]) : Promise.resolve();
        return preload.then(function () {
          if (gen !== window.__asSgQvGen) return;
          renderGallery(product, function () { leftReady = true; hideBusyState(); }, gen);
        });
      })
      .catch(function () { leftReady = true; hideBusyState(); });

    // Safety net: never let a busy state get stuck if a request stalls.
    setTimeout(function () {
      if (gen === window.__asSgQvGen) {
        $(".as_sg_qv-container").removeClass("as_sg_qv-loader");
        $("#as_sg_qv-content").removeClass("as_sg_qv-switching");
      }
    }, 8000);
  }

  // Resolves once the image has loaded (or failed), capped so a slow image
  // never holds up the switch.
  function preloadImage(src) {
    if (!src) return Promise.resolve();
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = img.onerror = resolve;
      img.src = src;
      setTimeout(resolve, 1500);
    });
  }

  // Fetch the details HTML, product JSON and main image for every color in
  // the modal's swatch row, so color swaps render from cache. Mouse users
  // already get this on hover; touch devices never hover.
  function prefetchSwatches() {
    $("#as_sg_qv-content .product-swatch").each(function () {
      if (!this.href || this.href.indexOf("/products/") === -1) return;
      var handle = this.href.split("/products/")[1].split("?")[0];
      if (handle === window.__asSgQvCurrentHandle) return;
      getPageHtml(this.href).catch(function () {});
      getProduct(handle)
        .then(function (product) { preloadImage((product.images || [])[0]); })
        .catch(function () {});
    });
  }

  function updateDemandText() {
    var el = document.querySelector("#as_sg_qv-content .as_sg_qv-demand-text");
    if (!el) return;

    var handle = window.__asSgQvCurrentHandle || "product";
    var storageKey = "as_sg_qv_demand_" + handle;

    var demand = localStorage.getItem(storageKey);
    if (!demand) {
      demand = 30 + Math.floor(Math.random() * 20);
      localStorage.setItem(storageKey, demand);
    }
    el.textContent = demand + " people bought this product recently.";
  }

  /* First open — from the Quick View button on a product card.
     Full loader is expected/fine here since the modal is empty anyway. */
  function openModalFor(handle, url) {
    $("#as_sg_qv-modal").addClass("as_sg_qv-active");
    $(".as_sg_qv-container").addClass("as_sg_qv-loader").scrollTop(0); // mobile scroll box

    window.__asSgQvCurrentHandle = handle;
    // Remember the ORIGINAL product this modal was opened with. Its own
    // swatch (once the container gets frozen/reused on the first color
    // switch) will never carry a real href, since on its own page "itself"
    // never links out. We use this to resolve clicks on that swatch.
    window.__asSgQvInitialHandle = handle;
    window.__asSgQvInitialUrl = url;

    destroySliders();
    $("#as_sg_qv-content .as_sg_qv-right-side-content").empty();
    $("#as_sg_qv-content .as_sg_qv-left-side-content").empty();

    populateModal(getProduct(handle), getPageHtml(url), handle, { isColorSwitch: false });
  }

  /* Color switch — from a swatch INSIDE an already-open modal.
     No full black loader (no flash), swatch row keeps its DOM/order,
     content just dims briefly while the new gallery/details load. */
  function switchColor(handle, url) {
    if (handle === window.__asSgQvCurrentHandle) return; // already showing this one

    $("#as_sg_qv-content").addClass("as_sg_qv-switching");
    // Optimistic active-state so the click feels instant.
    $("#as_sg_qv-content .product-swatch").each(function () {
      var h = this.href ? this.href.split("/products/")[1].split("?")[0] : null;
      if (!h && window.__asSgQvInitialHandle) {
        h = window.__asSgQvInitialHandle;
      }
      var isActive = !!h && h === handle;
      $(this)
        .toggleClass("as_sg_qv-swatch--active", isActive)
        .toggleClass("active", isActive)
        .toggleClass("selected", isActive)
        .toggleClass("is-selected", isActive)
        .toggleClass("current", isActive)
        .toggleClass("is-active", isActive);
      var $input = $(this).find('input[type="radio"], input[type="checkbox"]');
      if ($input.length) {
        $input.prop("checked", isActive);
      }
    });

    window.__asSgQvCurrentHandle = handle;

    // The current gallery is left in place (dimmed) — renderGallery swaps it
    // out once the new one is ready, so the modal never collapses/blinks.
    populateModal(getProduct(handle), getPageHtml(url), handle, { isColorSwitch: true });
  }

  function closeModal() {
    closeTip();
    $("#as_sg_qv-modal").removeClass("as_sg_qv-active");
    $("#as_sg_qv-content .as_sg_qv-right-side-content").empty();
    $("#as_sg_qv-content .as_sg_qv-left-side-content").empty();
    destroySliders();
  }

  /* ------------------------------------------------------------------
     MEMBERSHIP INFO TOOLTIP (blocks/membership-price.liquid), 768px+

     Its own CSS positions it absolutely inside the right column, which is
     a fixed-height scroll box here — so it got clipped on the left and at
     the bottom. It also only showed while the pointer was on the tiny (i)
     button, so it vanished before you could reach or scroll it.

     Here we own it instead (CSS hides it unless .as_sg_qv-tip--open):
     position: fixed so the column no longer clips it, placed under the
     button and clamped inside the modal, its body scrolls when it doesn't
     fit, and it stays open while the pointer is on the button OR the
     tooltip. Below 768px the whole modal scrolls, so that CSS still works.
  ------------------------------------------------------------------ */
  var TIP_OPEN_CLASS = "as_sg_qv-tip--open";
  var TIP_BUTTON = "#as_sg_qv-content .CP-ASplus-info-btn";
  var TIP_GAP = 20; // room for the arrow between the button and the tooltip
  var TIP_EDGE = 12; // minimum distance from the modal's edges
  var TIP_MIN_BODY = 80;
  var tipMedia = window.matchMedia("(min-width: 768px)");
  var openTip = null; // { btn, tip }
  var tipCloseTimer = null;

  function resetTipStyles(tip) {
    var body = tip.querySelector(".cp_asplus-body");
    var arrow = tip.querySelector(".cp_asplus-tooltip__arrow");
    tip.style.left = tip.style.top = tip.style.width = "";
    if (body) body.style.maxHeight = "";
    if (arrow) arrow.style.left = "";
  }

  function positionTip(btn, tip) {
    var container = document.querySelector(".as_sg_qv-container");
    if (!container) return;

    var bounds = container.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();
    var body = tip.querySelector(".cp_asplus-body");
    var arrow = tip.querySelector(".cp_asplus-tooltip__arrow");
    var maxWidth = bounds.width - TIP_EDGE * 2;

    // Measure from 0/0 to find where the containing block actually starts.
    // The modal container is transformed, which makes IT (not the viewport)
    // the containing block for position: fixed — this works either way.
    resetTipStyles(tip);
    tip.style.left = tip.style.top = "0px";
    if (tip.offsetWidth > maxWidth) tip.style.width = maxWidth + "px";
    var origin = tip.getBoundingClientRect();
    var width = origin.width;

    var btnCenter = btnRect.left + btnRect.width / 2;
    var left = Math.max(bounds.left + TIP_EDGE, Math.min(btnCenter - width / 2, bounds.right - TIP_EDGE - width));
    var top = btnRect.bottom + TIP_GAP;

    tip.style.left = left - origin.left + "px";
    tip.style.top = top - origin.top + "px";

    // Let the body scroll instead of running past the bottom of the modal
    if (body) {
      var available = Math.min(bounds.bottom, window.innerHeight) - TIP_EDGE - top;
      var chrome = tip.offsetHeight - body.offsetHeight;
      body.style.maxHeight = Math.max(TIP_MIN_BODY, available - chrome) + "px";
    }

    // Keep the arrow pointing at the button, wherever the tooltip got clamped
    if (arrow) {
      var arrowWidth = arrow.getBoundingClientRect().width;
      arrow.style.left = Math.max(0, Math.min(btnCenter - left - arrowWidth / 2, width - arrowWidth)) + "px";
    }
  }

  function openTipFor(btn) {
    var tip = btn.nextElementSibling;
    if (!tip || !tip.classList.contains("cp_asplus-tooltip")) return;

    clearTimeout(tipCloseTimer);
    if (openTip && openTip.tip === tip) return;
    closeTip();

    tip.classList.add(TIP_OPEN_CLASS);
    openTip = { btn: btn, tip: tip };
    positionTip(btn, tip);
  }

  function closeTip() {
    clearTimeout(tipCloseTimer);
    if (!openTip) return;

    openTip.tip.classList.remove(TIP_OPEN_CLASS);
    resetTipStyles(openTip.tip);
    openTip = null;
  }

  // Short grace period so crossing the gap from the button to the tooltip
  // doesn't close it
  function scheduleCloseTip() {
    clearTimeout(tipCloseTimer);
    tipCloseTimer = setTimeout(closeTip, 150);
  }

  function isInOpenTip(node) {
    return !!openTip && node instanceof Node && (openTip.btn.contains(node) || openTip.tip.contains(node));
  }

  document.addEventListener("mouseover", function (e) {
    if (!tipMedia.matches || !(e.target instanceof Element)) return;

    var btn = e.target.closest(TIP_BUTTON);
    if (btn) {
      openTipFor(btn);
    } else if (isInOpenTip(e.target)) {
      clearTimeout(tipCloseTimer);
    }
  });

  document.addEventListener("mouseout", function (e) {
    if (openTip && isInOpenTip(e.target) && !isInOpenTip(e.relatedTarget)) scheduleCloseTip();
  });

  document.addEventListener("focusin", function (e) {
    if (!tipMedia.matches || !(e.target instanceof Element)) return;
    var btn = e.target.closest(TIP_BUTTON);
    if (btn) openTipFor(btn);
  });

  document.addEventListener("focusout", function (e) {
    if (openTip && isInOpenTip(e.target) && !isInOpenTip(e.relatedTarget)) scheduleCloseTip();
  });

  // Tap/click support (touch tablets have no hover; macOS Safari doesn't
  // focus buttons on click): clicking the button opens, clicking elsewhere closes
  document.addEventListener("click", function (e) {
    if (!tipMedia.matches || !(e.target instanceof Element)) return;

    var btn = e.target.closest(TIP_BUTTON);
    if (btn) {
      openTipFor(btn);
    } else if (openTip && !isInOpenTip(e.target)) {
      closeTip();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeTip();
  });

  /* Below 768px the tooltip keeps the block's own absolute layout (the whole
     modal scrolls there), but it must be TAP-toggled rather than CSS
     :hover/:focus driven: iOS Safari never focuses a tapped <button> and
     drops its emulated :hover as soon as you touch to scroll, so the tooltip
     collapsed mid-scroll on real iPhones (Android Chrome and devtools do
     focus the button, which is why it only broke on iOS hardware). A scroll
     gesture doesn't fire a click, so it stays open while scrolling. */
  var TIP_TAP_CLASS = "as_sg_qv-tip--tap";

  document.addEventListener("click", function (e) {
    if (tipMedia.matches || !(e.target instanceof Element)) return;

    var open = document.querySelector("#as_sg_qv-content .cp_asplus-tooltip." + TIP_TAP_CLASS);
    var btn = e.target.closest(TIP_BUTTON);

    if (btn) {
      var tip = btn.nextElementSibling;
      if (!tip || !tip.classList.contains("cp_asplus-tooltip")) return;
      if (open) open.classList.remove(TIP_TAP_CLASS);
      if (tip !== open) tip.classList.add(TIP_TAP_CLASS);
    } else if (open && !open.contains(e.target)) {
      open.classList.remove(TIP_TAP_CLASS);
    }
  });

  // Scrolling the column moves the button, so follow it — or close if it
  // has scrolled out of view. Scrolls inside the tooltip itself are ignored.
  document.addEventListener(
    "scroll",
    function (e) {
      if (!openTip || (e.target instanceof Node && openTip.tip.contains(e.target))) return;

      var column = openTip.btn.closest(".as_sg_qv-right-side-content");
      var btnRect = openTip.btn.getBoundingClientRect();
      var columnRect = column ? column.getBoundingClientRect() : null;

      if (columnRect && (btnRect.bottom < columnRect.top || btnRect.top > columnRect.bottom)) {
        closeTip();
      } else {
        positionTip(openTip.btn, openTip.tip);
      }
    },
    true
  );

  window.addEventListener("resize", closeTip);
  if (typeof tipMedia.addEventListener === "function") tipMedia.addEventListener("change", closeTip);

  /* ------------------------------------------------------------------
     ADD TO CART (from inside the Quick View modal)
     AJAX add → refresh EVERY cart-drawer-component instance's HTML
     (line items/subtotal/count) → open the cart drawer → close the
     quick view modal. No page reload, and no duplicate add.

     Why interception happens on `window` (not `document`): this theme's
     own <product-form-component> has a document-level CAPTURE-phase
     submit listener (bound in its core component.js) that performs its
     OWN add-to-cart POST. Since capture-phase listeners fire in this
     order — window → document → ... → target — a listener we bind on
     `document` always runs AFTER the theme's, too late to stop it. But a
     capture-phase listener on `window` fires BEFORE document's, so THIS
     is where we can genuinely intercept and cancel the event before the
     theme's own handler ever sees it — preventing the double /cart/add.js
     call (and the doubled quantity/count it was causing) for good.
  ------------------------------------------------------------------ */
  function submitAddToCart($form) {
    var $btn = $form.find('[type="submit"]');
    if ($btn.prop("disabled")) return;

    // Re-read the live cart first, so the limit counts what's already in it
    loadCartQuantities().then(function () {
      refreshQuantityLimit(); // snap a still-being-typed quantity to the limit before sending

      // All available stock of this size is already in the cart: the button and
      // inline note now show that (updateMaxedState) - just don't add more
      var qtyWrap = $form.get(0) && $form.get(0).querySelector(".as_sg_qv-qty");
      if (qtyWrap && getQtyMax(qtyWrap) === 0) return;

      sendAddToCart($form);
    });
  }

  function sendAddToCart($form) {
    var formEl = $form.get(0);
    var formData = new FormData(formEl);
    var $submitBtn = $form.find('[type="submit"]');

    if ($submitBtn.prop("disabled")) return;
    $submitBtn.prop("disabled", true);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          console.error("as_sg_qv: add to cart failed", data.description || data.message);
          alert(data.description || "Could not add item to cart.");
          return Promise.reject(data);
        }

        closeModal();
        // This path swaps the drawer HTML directly and never fires the
        // theme's cart:update event, so invalidate the cache ourselves.
        clearHtmlCache();

        var $cartItemsComponent = $("cart-items-component").first();
        var sectionId = $cartItemsComponent.attr("data-section-id");
        if (!sectionId) return;

        return fetch("/?sections=" + sectionId)
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var html = sections[sectionId];
            if (!html) return;

            var doc = new DOMParser().parseFromString(html, "text/html");
            var newDrawer = doc.querySelector("cart-drawer-component");

            // Update EVERY cart-drawer-component instance on the page
            // (some themes render a second copy for a sticky/mobile
            // header) so the bubble count refreshes everywhere.
            if (newDrawer) {
              document.querySelectorAll("cart-drawer-component").forEach(function (oldDrawer) {
                oldDrawer.innerHTML = newDrawer.innerHTML;
              });
            }

            // Swapping innerHTML above wipes out the trigger button's own
            // click-binding, so open the drawer directly via the native
            // <dialog> API instead of relying on that button.
            var dialogEl = document.querySelector("cart-drawer-component dialog");
            if (dialogEl) {
              try {
                if (!dialogEl.open) {
                  if (typeof dialogEl.showModal === "function") {
                    dialogEl.showModal();
                  } else {
                    dialogEl.setAttribute("open", "");
                  }
                }
              } catch (dialogErr) {
                dialogEl.setAttribute("open", "");
              }
            } else {
              var cartDrawer = document.querySelector("cart-drawer-component");
              if (cartDrawer && typeof cartDrawer.open === "function") {
                cartDrawer.open();
              } else {
                var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
                if (trigger) trigger.click();
              }
            }
          });
      })
      .catch(function (err) {
        if (err && err.status) return; // already alerted above
        console.error("as_sg_qv: add to cart error", err);
      })
      .finally(function () {
        $submitBtn.prop("disabled", false);
      });
  }

  // Intercept on WINDOW, capture phase — fires before the theme's own
  // document-level capture listener, so we can genuinely stop it from
  // also running (see the long comment on submitAddToCart above).
  window.addEventListener(
    "submit",
    function (e) {
      var formEl = e.target && e.target.closest && e.target.closest("#as_sg_qv-modal .shopify-product-form");
      if (!formEl) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      submitAddToCart($(formEl));
    },
    true // capture = true
  );

  waitUntil(
    function () { return typeof window.jQuery === "function"; },
    function () {
      // Modal + buttons already exist in the DOM via Liquid — no injection,
      // no MutationObserver needed. Just bind delegated listeners once.

      /* Warm caches on hover so the modal opens instantly on click. */
      $(document).on("mouseenter", ".as_sg_qv-btn", function () {
        var handle = $(this).data("as-sg-qv-handle");
        var url = $(this).data("as-sg-qv-url");
        if (handle) getProduct(handle);
        if (url) getPageHtml(url);
      });

      $(document).on("mouseenter", ".product-swatch", function () {
        if (!this.href || this.href.indexOf("/products/") === -1) return;
        var handle = this.href.split("/products/")[1].split("?")[0];
        getProduct(handle);
        getPageHtml(this.href);
      });

      /* Size selector — updates add-to-cart state inside the modal.
         The CTA shows no price in Quick View (see renderDetails). */
      $(document).on("click", ".variant-option__button-label", function () {
        var $rightSide = $(this).closest(".as_sg_qv-right-side-content");
        var dataId = $(this).find("input").attr("data-variant-id");
        var $addToCartText = $rightSide.find(".add-to-cart-text");

        $rightSide.find(".shopify-product-form input[name='id']").val(dataId);

        if ($(this).find("input").attr("data-option-available") === "true") {
          // Reuse the label the modal opened with, unless that was "Sold out"
          var label = $addToCartText.attr("data-as-sg-qv-label");
          if (!label || /sold out/i.test(label)) label = "Add To Cart";
          setAddToCartLabel($addToCartText, label);
          $rightSide.find(".add-to-cart-button:not(.button-secondary)").removeAttr("disabled");
        } else {
          setAddToCartLabel($addToCartText, "Sold out");
          $rightSide.find(".add-to-cart-button:not(.button-secondary)").attr("disabled", true);
        }

        // After the availability state above, so "max in cart" can override it
        refreshQuantityLimit();
      });

      /* Open modal from a product card's Quick View button. */
      $(document).on("click", ".as_sg_qv-btn", function (e) {
        e.preventDefault();
        var handle = $(this).data("as-sg-qv-handle");
        var url = $(this).data("as-sg-qv-url");
        openModalFor(handle, url);
      });

      /* Close modal. */
      $(document).on("click", ".as_sg_qv-close, .as_sg_qv-overlay", function () {
        closeModal();
      });

      /* Change color variant inside the modal (swatch → different product). */
      $(document).on("click", "#as_sg_qv-modal .product-swatch", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = this.href;
        var handle;

        if (!url || url.indexOf("/products/") === -1) {
          // This swatch has no real href — it's the "self" swatch frozen
          // into the reused container from the product the modal was
          // FIRST opened with. Resolve it back to that original product.
          handle = window.__asSgQvInitialHandle;
          url = window.__asSgQvInitialUrl;
        } else {
          handle = url.split("/products/")[1].split("?")[0];
        }

        if (!handle || !url) return;

        switchColor(handle, url);
        return false;
      });

      /* Add to cart is handled by the window-capture listener defined
         above (submitAddToCart) — nothing additional needed here. */
    }
  );
})();